export default "__VITE_ASSET__vJcA6nkA__"